import React from 'react'
import styles from '../../styles.module.css'
import { METRICS_TOP, METRICS_MONITORING, MONITORING_SECTION_TITLE, fmt } from '../metrics'


const SummaryTable = ({ row, academicYear }) => {
  const yearTitle = academicYear
    ? `в ${academicYear} учебном году`
    : 'за учебный год'

  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft}>
            {`Сведения об успеваемости и качестве учебы ${yearTitle}`}
          </th>
          <th className={styles.titleRight}>Форма №2/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft}>{row.organizationName}</th>
          <th className={styles.titleRight}>Таблица №1</th>
        </tr>
      </thead>
      <tbody>
        {METRICS_TOP.map(m => (
          <tr key={m.key}>
            <td>{m.label}</td>
            <td className={styles.valueCell}>{fmt(row[m.key])}</td>
          </tr>
        ))}
        <tr className={styles.sectionRow}>
          <td colSpan={2}>{MONITORING_SECTION_TITLE}</td>
        </tr>
        {METRICS_MONITORING.map(m => (
          <tr key={m.key}>
            <td>{m.label}</td>
            <td className={styles.valueCell}>{fmt(row[m.key])}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default SummaryTable
